import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

export const bonusSettlementsState = (state: AppState) => state.bonusSettlements;

export const bonusSettlementsSupplierOverviewSelector = createSelector(
    bonusSettlementsState,
    state => state.supplierOverview.bonusSettlementsSupplierOverview
);
export const bonusSettlementsSupplierOverviewRequestingSelector = createSelector(
    bonusSettlementsState,
    state => state.supplierOverview.requesting
);
export const bonusSettlementsSupplierOverviewDetailsSelector = createSelector(
    bonusSettlementsState,
    state => state.supplierOverview.details
);
